const LinkFooter = () => null;

export default LinkFooter;
